export default "__VITE_ASSET__DnV0m4dC__"